import React, { SyntheticEvent } from 'react';
import FormField from 'lib/src/components/form/FormField';
import { FormInputProps } from 'lib/src/types/shared/FormInputProps';
import useFieldValidation from './hooks/useFieldValidation';

const AssessmentSlider: React.FC<RangeInputProps> = ({
    name,
    value,
    onChange,
    label = '',
    required = false,
    disabled,
    customValidate,
    fieldClassName,
    forceAsterisk = false,
    min = 1,
    max = 5,
}) => {
    const [error, showError] = useFieldValidation({
        name,
        required,
        value,
        customValidate,
    });

    return (
        <FormField
            name={name}
            label={label}
            required={required}
            error={error}
            className={fieldClassName}
            forceAsterisk={forceAsterisk}
        >
            <input
                type="range"
                className={`form-input assessment-slider ${error ? 'error' : ''} score-${value}`}
                name={name}
                id={name}
                min={min}
                max={max}
                step={1}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled}
            />

            <div className="assessment-slider-ratings flex-row justify-between">
                {[...Array(max)].map((_, i) => (
                    <p key={i} onClick={() => onChange(name, i + 1)}>
                        {i + 1}
                    </p>
                ))}
            </div>
        </FormField>
    );

    function handleBlur() {
        showError();
    }

    function handleChange(e: SyntheticEvent) {
        e.preventDefault();
        const newVal = +(e.target as HTMLInputElement).value;
        onChange(name, newVal);
    }
};

interface RangeInputProps extends FormInputProps<number> {
    label?: string;
    min?: number;
    max?: number;
    fieldClassName?: string;
    forceAsterisk?: boolean;
}

export default AssessmentSlider;
